import { extendTheme } from "@chakra-ui/react";
import { createBreakpoints } from "@chakra-ui/theme-tools";

import { Form } from "./components";
import { colors, font, effects, breakpoints } from "./utilities"


const theme = extendTheme({
    colors,
    effects,
    font,
    breakpoints,
    sizes: {
        container: {
            sm: "375px",
            md: "1024px",
            lg: "1280px",
            xl: "1920px",
            "2xl": "2160px",
        }
    },
    components: {
        Form,
    }
});


export default theme;